import './main.scss';
import Cards from './Cards';

function Main() {
return (
    <main className="main">
        <img   loading="lazy" className="disc"alt = "" src = "/img/disc.png"></img>
        <Cards/>
    </main>
);
}
export default Main;
